import { render } from "./Queries.vue?vue&type=template&id=7817be1c&scoped=true"
import script from "./Queries.vue?vue&type=script&lang=js"
export * from "./Queries.vue?vue&type=script&lang=js"

import "./Queries.vue?vue&type=style&index=0&id=7817be1c&scoped=true&lang=css"
import "./Queries.vue?vue&type=style&index=1&id=7817be1c&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7817be1c"]])

export default __exports__